import { render, staticRenderFns } from "./BaskoBoxPaymentTypeList.vue?vue&type=template&id=58b4ebd2&"
import script from "./BaskoBoxPaymentTypeList.vue?vue&type=script&lang=js&"
export * from "./BaskoBoxPaymentTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports